import axios from "axios";

import { objectKeysToCamelCase } from "../../../../_common/utils/string";

export function getLead({ id, preVendedorId, gate, gateAnterior }) {
  return axios
    .get(`/api/pipeline/lead/flyout?id=${id}&preVendedorId=${preVendedorId}&gate=${gate}&gateAnterior=${gateAnterior}`)
    .then(({ data }) => objectKeysToCamelCase(data));
}
